<template>
  <div>
    <Navbar :menus="menus" :loanMenus="loanMenus" :savingMenus="savingMenus" :slugEn="slugEn" :slugId="slugId" />
    <main>
      <Floatingbutton />
      <slot />
    </main>
    <TheFooter :loanMenus="loanMenus" :savingMenus="savingMenus"/>
  </div>
</template>

<script>
import Navbar from "@/Shared/Navbar";
import TheFooter from "@/Shared/TheFooter";
import Floatingbutton from "@/Shared/Floatingbutton";

export default {
  components: {
    Navbar,
    TheFooter,
    Floatingbutton,
  },
  props: {
    menus: Object,
    loanMenus: Object,
    savingMenus: Object,
    slugEn: String,
    slugId: String,
  }
};
</script>
